import { Location } from 'history';
import { useEffect } from 'react';
import { useHistory } from 'react-router';

import { BaseRow } from '@sbu/components.datagrid';

import { useDataGridPageContext } from '../DataGridPageContext';

export function useNavigationBlocker<Row extends BaseRow>() {
  const history = useHistory();

  const {
    shouldPromptDiscard,
    isDiscardDialogOpen,
    onNavigate,
    allowRedirect,
  } = useDataGridPageContext<Row>();

  useEffect(() => {
    if (isDiscardDialogOpen || allowRedirect) {
      return;
    }

    const unblock = history.block((nextLocation: Location) => {
      if (shouldPromptDiscard) {
        onNavigate(nextLocation);
        return false;
      }
    });

    return () => {
      unblock();
    };
  }, [
    isDiscardDialogOpen,
    history,
    shouldPromptDiscard,
    onNavigate,
    allowRedirect,
  ]);
}
